<div mat-dialog-title class="d-flex align-center justify-content-between mb-0 w-full">
  <span class="title t-title-medium">{{ options?.title }}</span>
  <button *ngIf="options.hasCloseButton" mat-icon-button [mat-dialog-close]="options?.closeAction">
    <mat-icon class="icon-button">clear</mat-icon>
  </button>
</div>
<div mat-dialog-content class="t-body-text-medium p-24">
  <p class="text">{{ options?.text | translate | async }}</p>
  <p class="additionText mt-4">{{ options?.additionText | translate | async }}</p>
</div>
<div mat-dialog-actions class="justify-content-between">
  <div class="buttons">
    <ng-container *ngIf="options.buttons">
      <button
        matRipple
        class="t-footnote-semibold"
        [class.btn-success]="button.color === 'success'"
        [class.btn-cancel]="button.color === 'empty'"
        [class.btn-delete]="button.color === 'error'"
        *ngFor="let button of options.buttons"
        (click)="onSubmit(button.action)"
      >
        {{ button.caption | translate | async }}
      </button>
    </ng-container>
    <ng-container *ngIf="!options.buttons">
      <button matRipple class="btn-cancel t-footnote-semibold" (click)="onClose()">
        {{ 'Cancel' | translate | async }}
      </button>

      <button matRipple class="btn-success t-footnote-semibold" (click)="onSubmit(true)">
        {{ 'Yes' | translate | async }}
      </button>
    </ng-container>
  </div>
</div>
